export default {
    intro: `Có những biểu đạt không tự nhiên hoặc sai lẫn trong đó.<br />Hãy tìm phần không tự nhiên và sửa lại cho đúng!`,
    select: 'Hãy chọn', fill: 'Hãy sửa phần không tự nhiên cho tự nhiên hơn!',
    wrong: 'Ồ, sai rồi. Hãy thử lại nhé.', find: 'Hãy tìm và nhấn vào phần không tự nhiên.',
    findCount: 'còn lại.',
    table: { question: 'Câu hỏi', answerRate: 'Độ chính xác', emptyMessage: 'Không có nội dung.' },
};
